
.full-container {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom:0px;
}

.full-container-pane {
  width: 100%;
  height: 100%;
}

.top-container {
  min-height: 300px;
  height: 100%;
}

.pg-debugger-panel {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0; bottom: 0; right: 0; left: 0;
}